import { render, staticRenderFns } from "./ReviewDecline.vue?vue&type=template&id=38aff7b8&scoped=true&"
import script from "./ReviewDecline.vue?vue&type=script&lang=js&"
export * from "./ReviewDecline.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDecline.vue?vue&type=style&index=0&id=38aff7b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aff7b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VIcon,VSubheader})
